/* 防止脚本被多次加载时重复声明 */
if (window.__quizModalJsLoaded) { /* noop */ } else {
window.__quizModalJsLoaded = true;

/**
 * Quiz Modal Component - 产品推荐测验弹窗
 * 通过问卷引导用户选择最适合的产品型号
 *
 * 状态机步骤:
 * neckSize → dogProfile(不确定) / fenceNeed(颈围偏小) → fenceArea
 *   → fenceNeed(< 0.5 acre) → result
 *   → distance(≥ 0.5 acre) → signal → environment → signalRisk(条件) → result/tooSmall
 *
 * 推荐逻辑:
 * - 颈围 >30 → NOT_RECOMMENDED
 * - < 0.5 acre + Essential → NOT_RECOMMENDED / + Not essential → Collar Go
 * - ≥ 0.5 acre + ≤50ft → D1+Beacon
 * - ≥ 0.5 acre + >50ft + Poor → NOT_RECOMMENDED
 * - ≥ 0.5 acre + >50ft + Good/Fair + Residential/Open → D1
 * - ≥ 0.5 acre + >50ft + Good/Fair + DenseWoods/City + Essential → NOT_RECOMMENDED
 * - ≥ 0.5 acre + >50ft + Good/Fair + DenseWoods/City + Not essential → Collar Go
 * - ≥ 0.5 acre + >50ft + Good/Fair + Other → NOT_RECOMMENDED
 *
 * 文案由 Liquid 模板从 locales/en.default.json 注入，JS 只负责逻辑
 */

// ========================================
// 推荐结果常量
// ========================================
var QUIZ_RESULTS = {
  NOT_RECOMMENDED: 'NOT_RECOMMENDED',
  RECOMMEND_COLLAR_GO: 'RECOMMEND_COLLAR_GO',
  RECOMMEND_COLLAR_BEACON: 'RECOMMEND_COLLAR_BEACON',
  RECOMMEND_COLLAR: 'RECOMMEND_COLLAR'
};

// ========================================
// 步骤定义
// ========================================
var QUIZ_STEPS = {
  neckSize: 'neckSize',
  fenceNeed: 'fenceNeed',   // 颈围偏小 或 小院子(< 0.5 acre)：是否需要虚拟围栏
  dogProfile: 'dogProfile',
  neckEstimateResult: 'neckEstimateResult',
  fenceArea: 'fenceArea',
  distance: 'distance',
  signal: 'signal',
  signalRisk: 'signalRisk',
  environment: 'environment',
  result: 'result',
  tooSmall: 'tooSmall'
};

// 用于进度计算的主流程步骤（不含条件分支和结果页）
var MAIN_STEPS = ['neckSize', 'fenceArea', 'distance', 'signal', 'environment'];

// ========================================
// 本地颈围估算算法（参考 collar-fit.js）
// ========================================
var COLLAR_FIT_DOG_BREEDS = [
  { name: 'Mixed Breed', neckFactor: 1.00, adultWeight: [5, 35] },
  { name: 'Chihuahua', neckFactor: 0.90, adultWeight: [1.5, 3] },
  { name: 'Yorkshire Terrier', neckFactor: 0.90, adultWeight: [2, 3.5] },
  { name: 'Pomeranian', neckFactor: 1.00, adultWeight: [1.5, 3.5] },
  { name: 'Maltese', neckFactor: 0.90, adultWeight: [2, 4] },
  { name: 'Dachshund', neckFactor: 0.95, adultWeight: [5, 12] },
  { name: 'Shih Tzu', neckFactor: 1.00, adultWeight: [4, 7] },
  { name: 'Toy Poodle', neckFactor: 0.85, adultWeight: [2, 4] },
  { name: 'Miniature Poodle', neckFactor: 0.90, adultWeight: [5, 8] },
  { name: 'Miniature Schnauzer', neckFactor: 1.00, adultWeight: [5, 8] },
  { name: 'Jack Russell Terrier', neckFactor: 1.00, adultWeight: [5, 8] },
  { name: 'Cavalier King Charles', neckFactor: 0.95, adultWeight: [5, 8] },
  { name: 'French Bulldog', neckFactor: 1.35, adultWeight: [8, 14] },
  { name: 'Pug', neckFactor: 1.25, adultWeight: [6, 9] },
  { name: 'Boston Terrier', neckFactor: 1.15, adultWeight: [5, 11] },
  { name: 'Corgi', neckFactor: 1.10, adultWeight: [10, 14] },
  { name: 'Beagle', neckFactor: 1.05, adultWeight: [9, 14] },
  { name: 'Cocker Spaniel', neckFactor: 1.00, adultWeight: [10, 15] },
  { name: 'Border Collie', neckFactor: 0.95, adultWeight: [14, 22] },
  { name: 'Australian Shepherd', neckFactor: 1.00, adultWeight: [18, 29] },
  { name: 'Siberian Husky', neckFactor: 1.05, adultWeight: [16, 27] },
  { name: 'Samoyed', neckFactor: 1.10, adultWeight: [16, 30] },
  { name: 'Standard Poodle', neckFactor: 0.90, adultWeight: [18, 32] },
  { name: 'Dalmatian', neckFactor: 0.95, adultWeight: [20, 32] },
  { name: 'Vizsla', neckFactor: 0.90, adultWeight: [18, 29] },
  { name: 'Brittany Spaniel', neckFactor: 0.95, adultWeight: [14, 20] },
  { name: 'English Springer Spaniel', neckFactor: 1.00, adultWeight: [18, 25] },
  { name: 'Whippet', neckFactor: 0.80, adultWeight: [9, 18] },
  { name: 'Shar-Pei', neckFactor: 1.25, adultWeight: [18, 27] },
  { name: 'Bulldog (English)', neckFactor: 1.40, adultWeight: [18, 25] },
  { name: 'Staffordshire Bull Terrier', neckFactor: 1.30, adultWeight: [11, 17] },
  { name: 'American Pit Bull', neckFactor: 1.30, adultWeight: [16, 30] },
  { name: 'Chow Chow', neckFactor: 1.20, adultWeight: [20, 32] },
  { name: 'Basset Hound', neckFactor: 1.15, adultWeight: [20, 30] },
  { name: 'Labrador Retriever', neckFactor: 1.05, adultWeight: [25, 36] },
  { name: 'Golden Retriever', neckFactor: 1.00, adultWeight: [25, 34] },
  { name: 'German Shepherd', neckFactor: 1.05, adultWeight: [22, 40] },
  { name: 'Boxer', neckFactor: 1.15, adultWeight: [25, 36] },
  { name: 'Doberman', neckFactor: 1.00, adultWeight: [27, 45] },
  { name: 'Belgian Malinois', neckFactor: 1.00, adultWeight: [20, 34] },
  { name: 'Rhodesian Ridgeback', neckFactor: 1.05, adultWeight: [30, 40] },
  { name: 'Weimaraner', neckFactor: 0.95, adultWeight: [25, 40] },
  { name: 'Irish Setter', neckFactor: 0.90, adultWeight: [25, 32] },
  { name: 'Greyhound', neckFactor: 0.80, adultWeight: [25, 40] },
  { name: 'Akita', neckFactor: 1.20, adultWeight: [27, 45] },
  { name: 'Alaskan Malamute', neckFactor: 1.15, adultWeight: [30, 45] },
  { name: 'Great Dane', neckFactor: 1.00, adultWeight: [45, 80] },
  { name: 'Saint Bernard', neckFactor: 1.20, adultWeight: [55, 80] },
  { name: 'Newfoundland', neckFactor: 1.20, adultWeight: [45, 70] },
  { name: 'Bernese Mountain Dog', neckFactor: 1.10, adultWeight: [35, 55] },
  { name: 'Mastiff (English)', neckFactor: 1.30, adultWeight: [55, 100] },
  { name: 'Bullmastiff', neckFactor: 1.30, adultWeight: [45, 60] },
  { name: 'Rottweiler', neckFactor: 1.25, adultWeight: [35, 60] },
  { name: 'Cane Corso', neckFactor: 1.25, adultWeight: [38, 55] },
  { name: 'Great Pyrenees', neckFactor: 1.15, adultWeight: [38, 55] },
  { name: 'Irish Wolfhound', neckFactor: 0.95, adultWeight: [48, 70] },
  { name: 'Leonberger', neckFactor: 1.15, adultWeight: [40, 75] },
  { name: 'Tibetan Mastiff', neckFactor: 1.30, adultWeight: [35, 75] },
  { name: 'Borzoi', neckFactor: 0.80, adultWeight: [27, 48] },
  { name: 'Saluki', neckFactor: 0.80, adultWeight: [16, 29] },
  { name: 'Azawakh', neckFactor: 0.75, adultWeight: [15, 25] },
  { name: 'Scottish Deerhound', neckFactor: 0.85, adultWeight: [34, 50] },
  { name: 'Pharaoh Hound', neckFactor: 0.85, adultWeight: [18, 27] },
  { name: 'Xoloitzcuintli', neckFactor: 0.80, adultWeight: [10, 25] },
  { name: 'Dogo Argentino', neckFactor: 1.25, adultWeight: [35, 45] },
  { name: 'Dogue de Bordeaux', neckFactor: 1.30, adultWeight: [45, 65] },
  { name: 'Neapolitan Mastiff', neckFactor: 1.30, adultWeight: [50, 70] },
  { name: 'Presa Canario', neckFactor: 1.25, adultWeight: [38, 57] },
  { name: 'Fila Brasileiro', neckFactor: 1.25, adultWeight: [40, 60] },
  { name: 'Spanish Mastiff', neckFactor: 1.20, adultWeight: [50, 75] },
  { name: 'Caucasian Shepherd', neckFactor: 1.20, adultWeight: [45, 75] },
  { name: 'Bouvier des Flandres', neckFactor: 1.10, adultWeight: [27, 40] },
  { name: 'Bergamasco Sheepdog', neckFactor: 1.10, adultWeight: [26, 38] },
  { name: 'Kangal', neckFactor: 1.10, adultWeight: [40, 65] },
  { name: 'Anatolian Shepherd', neckFactor: 1.10, adultWeight: [40, 65] },
  { name: 'Hovawart', neckFactor: 1.05, adultWeight: [25, 40] },
  { name: 'Eurasier', neckFactor: 1.05, adultWeight: [18, 32] },
  { name: 'Finnish Lapphund', neckFactor: 1.05, adultWeight: [15, 24] },
  { name: 'Norwegian Elkhound', neckFactor: 1.05, adultWeight: [20, 27] },
  { name: 'Bloodhound', neckFactor: 1.15, adultWeight: [36, 50] }
];

var COLLAR_FIT_DOG_ANCHORS = [
  [2, 6.0, 8.0],
  [5, 8.0, 10.5],
  [8, 9.5, 12.0],
  [12, 11.0, 14.0],
  [16, 13.0, 16.0],
  [20, 14.5, 17.5],
  [25, 16.0, 19.5],
  [30, 17.5, 21.0],
  [35, 19.0, 23.0],
  [40, 20.0, 24.5],
  [50, 21.5, 26.0],
  [60, 23.0, 28.0],
  [75, 25.0, 30.0],
  [90, 27.0, 33.0]
];

// ========================================
// QuizModalComponent 类
// ========================================

class QuizModalComponent {
  constructor() {
    this.breedsData = null; // 缓存品种数据
    this.debounceTimer = null;
    this.closeTimer = null;
    this.activeData = null;
    this.globalOpenHandler = this.handleGlobalOpen.bind(this);
    this.globalListenersRegistered = false;
    this.quizProductProperties = null;
  }

  /**
   * 初始化 Alpine.data 返回对象
   */
  init() {
    var self = this;

    return {
      // ======== 弹窗状态 ========
      show: false,
      quizId: '',
      currentStep: QUIZ_STEPS.neckSize,
      history: [], // 回退栈
      loading: false,
      error: '',
      entryPoint: '',

      // ======== 答案存储 ========
      answers: {
        neckSizeKnown: '', // 'fits' | 'small' | 'large' | 'unknown'
        fenceNeed: '',     // 'essential' | 'trackingOnly'（颈围偏小时的围栏需求）
        breed: '',
        ageMonths: 24,
        weightLbs: 40,
        estimatedNeckSize: null,
        estimatedNeckMin: null,
        estimatedNeckMax: null,
        estimatedConfidence: '',
        estimatedWarnings: [],
        fenceArea: '', // 'small' | 'large'
        distance: '', // 'close' | 'far'
        signal: '', // 'good' | 'fair' | 'poor'
        signalRisk: '', // 'needFence' | 'trackingOnly'
        environment: '' // 'suburban' | 'rural' | 'denseWoods' | 'city' | 'other'
      },

      // ======== 结果页产品状态 ========
      productData: {
        collar: null,   // { title, image, variants: [{id, title, available}] }
        collarGo: null,
        beacon: null
      },
      productsLoading: false,
      selectedVariantId: {
        collar: null,
        collarGo: null,
        beacon: null
      },
      addingToCart: false,   // 加购 loading 状态
      cartSuccess: false,    // 加购成功状态
      cartError: '',         // 加购失败错误提示

      // ======== 品种搜索状态 ========
      breedsLoaded: false, // 品种数据是否加载完成
      breedSearch: '',
      filteredBreeds: [],
      showBreedDropdown: false,
      featuredBreeds: [],
      weightUnit: 'lbs',

      // ======== 计算属性 ========

      /** 当前进度百分比 */
      get progressPercent() {
        var stepIndex = MAIN_STEPS.indexOf(this.currentStep);
        if (this.currentStep === 'dogProfile') stepIndex = 0;    // 跟 neckSize 同级
        if (this.currentStep === 'fenceNeed') stepIndex = 1;     // 跟 fenceArea 同级
        if (this.currentStep === 'signalRisk') stepIndex = 4;    // 跟 environment 同级
        if (this.currentStep === 'result' || this.currentStep === 'tooSmall') return 100;
        if (stepIndex < 0) return 0;
        return Math.round(((stepIndex + 1) / (MAIN_STEPS.length + 1)) * 100);
      },

      /** 当前步骤是否可以前进 */
      get canGoNext() {
        switch (this.currentStep) {
          case 'neckSize':
            return this.answers.neckSizeKnown !== '';
          case 'fenceNeed':
            return this.answers.fenceNeed !== '';
          case 'dogProfile':
            return this.answers.breed !== '' &&
              Number(this.answers.ageMonths) > 0 &&
              Number(this.answers.weightLbs) > 0;
          case 'neckEstimateResult':
            return this.answers.estimatedNeckSize !== null;
          case 'fenceArea':
            return this.answers.fenceArea !== '';
          case 'distance':
            return this.answers.distance !== '';
          case 'signal':
            return this.answers.signal !== '';
          case 'signalRisk':
            return this.answers.signalRisk !== '';
          case 'environment':
            return this.answers.environment !== '';
          default:
            return false;
        }
      },

      /** 获取有效颈围（区间选择返回代表值，估算的用估算值） */
      get effectiveNeckSize() {
        switch (this.answers.neckSizeKnown) {
          case 'fits': return 20;    // 14-30 范围内，取中间值
          case 'small': return 13;   // <14 偏小
          case 'large': return 32;   // >30 超出
          case 'unknown': return this.answers.estimatedNeckSize || 0;
          default: return 0;
        }
      },

      lbsToKg(value) {
        return Math.max(1, Math.min(91, Math.round(Number(value || 0) / 2.20462)));
      },

      kgToLbs(value) {
        return Math.max(2, Math.min(200, Math.round(Number(value || 0) * 2.20462)));
      },

      switchWeightUnit(unit) {
        this.weightUnit = unit === 'kg' ? 'kg' : 'lbs';
      },

      getWeightDisplayValue() {
        return this.weightUnit === 'kg'
          ? this.lbsToKg(this.answers.weightLbs)
          : Number(this.answers.weightLbs);
      },

      getWeightUnitLabel() {
        return this.weightUnit;
      },

      getWeightSliderMin() {
        return this.weightUnit === 'kg' ? 1 : 2;
      },

      getWeightSliderMax() {
        return this.weightUnit === 'kg' ? 91 : 200;
      },

      getWeightSliderValue() {
        return this.weightUnit === 'kg'
          ? this.lbsToKg(this.answers.weightLbs)
          : Number(this.answers.weightLbs);
      },

      getWeightSliderLabel(position) {
        var value = position === 'min' ? this.getWeightSliderMin() : this.getWeightSliderMax();
        return value + ' ' + this.getWeightUnitLabel();
      },

      onWeightSliderInput(event) {
        var nextValue = Number(event && event.target ? event.target.value : 0);
        if (this.weightUnit === 'kg') {
          this.answers.weightLbs = this.kgToLbs(nextValue);
          return;
        }
        this.answers.weightLbs = Math.max(2, Math.min(200, Math.round(nextValue)));
      },

      roundToHalf(value) {
        return Math.round(Number(value || 0) * 2) / 2;
      },

      formatInches(value) {
        return this.roundToHalf(value).toFixed(1);
      },

      getEstimatedRange() {
        if (this.answers.estimatedNeckSize === null) return null;

        if (this.answers.estimatedNeckMin !== null && this.answers.estimatedNeckMax !== null) {
          return {
            min: this.roundToHalf(this.answers.estimatedNeckMin),
            max: this.roundToHalf(this.answers.estimatedNeckMax)
          };
        }

        var spread = this.answers.estimatedConfidence === 'high' ? 1 : 2;
        var base = Number(this.answers.estimatedNeckSize);
        var min = Math.max(4, Math.min(40, base - spread));
        var max = Math.max(4, Math.min(40, base + spread));

        return {
          min: this.roundToHalf(min),
          max: this.roundToHalf(max)
        };
      },

      getEstimatedRangeLabel() {
        var range = this.getEstimatedRange();
        if (!range) return '';
        return this.formatInches(range.min) + '-' + this.formatInches(range.max) + ' inches';
      },

      getEstimateResultState() {
        var range = this.getEstimatedRange();
        if (!range) return 'idle';
        if (range.max < 14 || range.min > 30) return 'no';
        if (range.min >= 14 && range.max <= 30) return 'fit';
        return 'maybe';
      },

      getEstimateTrackStyle() {
        return {
          left: '0%',
          width: '100%'
        };
      },

      getEstimateCollarRangeStyle() {
        var trackMin = 0;
        var trackMax = 40;
        var collarMin = 14;
        var collarMax = 30;

        return {
          left: ((collarMin - trackMin) / (trackMax - trackMin) * 100) + '%',
          width: ((collarMax - collarMin) / (trackMax - trackMin) * 100) + '%'
        };
      },

      getEstimatePetRangeStyle() {
        var range = this.getEstimatedRange();
        if (!range) {
          return {
            left: '0%',
            width: '0%'
          };
        }

        var trackMin = 0;
        var trackMax = 40;
        var clampedMin = Math.max(trackMin, Math.min(trackMax, range.min));
        var clampedMax = Math.max(trackMin, Math.min(trackMax, range.max));

        return {
          left: ((clampedMin - trackMin) / (trackMax - trackMin) * 100) + '%',
          width: Math.max(3, ((clampedMax - clampedMin) / (trackMax - trackMin) * 100)) + '%'
        };
      },

      shouldShowProductSkeleton(key) {
        return this.productsLoading && !this.productData[key];
      },

      shouldShowBeaconSkeleton() {
        return this.productsLoading && (!this.productData.collar || !this.productData.beacon);
      },

      clearCloseTimer() {
        if (self.closeTimer) {
          clearTimeout(self.closeTimer);
          self.closeTimer = null;
        }
      },

      releaseThemeUiState(options) {
        options = options || {};

        if (!window.Alpine || !Alpine.store) return;

        var modal = Alpine.store('xModal');
        if (modal) {
          try {
            if (modal.activeElement && typeof modal.removeFocus === 'function') {
              modal.removeFocus();
            }
          } catch (err) {}
          modal.activeElement = '';
        }

        if (options.preserveCart) return;

        var miniCart = Alpine.store('xMiniCart');
        if (miniCart) {
          if (miniCart.open && typeof miniCart.hideCart === 'function') {
            miniCart.hideCart();
          } else {
            miniCart.open = false;
          }
        }

        var popup = Alpine.store('xPopup');
        if (popup) {
          if (typeof popup.close === 'function') {
            popup.close();
          }
          popup.open = false;
        }
      },

      // ======== 生命周期方法 ========

      /** Alpine init 回调 */
      alpineInit() {
        self.activeData = this;
        self.loadBreedsData(this);
        this.$nextTick(function() { this.updateBodyHeight(); }.bind(this));
      },

      /**
       * 更新 .quiz-modal-body 高度以匹配当前步骤面板
       * 配合 CSS transition 实现平滑过渡
       */
      updateBodyHeight() {
        var body = this.$root.querySelector('.quiz-modal-body');
        if (!body) return;
        var panels = body.querySelectorAll('.quiz-modal-step-panel');
        for (var i = 0; i < panels.length; i++) {
          if (panels[i].style.display !== 'none' && panels[i].offsetHeight > 0) {
            // 计算可用高度：以视口 96vh 为上限（对应 CSS max-height: 96vh）
            // 不用 container.offsetHeight，避免旧步骤高度影响新步骤的可用空间
            var container = this.$root;
            var header = container.querySelector('.quiz-modal-header');
            var footer = container.querySelector('.quiz-modal-footer');
            var headerH = header ? header.offsetHeight : 0;
            var footerH = footer ? footer.offsetHeight : 0;
            var containerMaxH = Math.floor(window.innerHeight * 0.96);
            var maxBodyH = containerMaxH - headerH - footerH;
            var targetH = panels[i].scrollHeight;
            body.style.height = (maxBodyH > 0 ? Math.min(targetH, maxBodyH) : targetH) + 'px';
            return;
          }
        }
      },

      // ======== 弹窗控制 ========

      /**
       * 打开 Quiz 弹窗
       * @param {Object} detail - 事件 detail（包含 entryPoint）
       */
      openQuiz(detail) {
        this.clearCloseTimer();
        this.currentStep = QUIZ_STEPS.neckSize;
        this.history = [];
        this.loading = false;
        this.error = '';
        this.entryPoint = (detail && detail.entryPoint) || 'unknown';
        this.breedSearch = '';
        this.filteredBreeds = [];
        this.showBreedDropdown = false;
        this.productData = { collar: null, collarGo: null, beacon: null };
        this.productsLoading = false;
        this.selectedVariantId = { collar: null, collarGo: null, beacon: null };
        this.addingToCart = false;
        this.cartSuccess = false;
        this.cartError = '';
        this.weightUnit = 'lbs';

        this.answers = {
          neckSizeKnown: '',
          fenceNeed: '',
          breed: '',
          ageMonths: 24,
          weightLbs: 40,
          estimatedNeckSize: null,
          estimatedNeckMin: null,
          estimatedNeckMax: null,
          estimatedConfidence: '',
          estimatedWarnings: [],
          fenceArea: '',
          distance: '',
          signal: '',
          signalRisk: '',
          environment: ''
        };

        this.quizId = self.generateUUID();
        this.sessionId = self.getOrCreateSessionId();
        document.body.style.overflow = 'hidden';
        this.show = true;
        this.$nextTick(function() { this.updateBodyHeight(); }.bind(this));

        this.trackEvent('quiz_start', {
          quiz_id: this.quizId,
          entry_point: this.entryPoint
        });

        // 将 Section settings 注入的 hidden 图片复制到可见容器中
        this.$nextTick(function() { self.populateRefImages(); }.bind(this));
      },

      /** 关闭 Quiz 弹窗 */
      closeQuiz(options) {
        this.clearCloseTimer();
        if (this.currentStep !== 'result' && this.currentStep !== 'tooSmall') {
          this.trackEvent('quiz_abandon', {
            quiz_id: this.quizId,
            step: this.currentStep,
            total_steps_taken: this.history.length
          });
        }
        this.show = false;
        document.body.style.overflow = '';
        this.$nextTick(function() {
          var body = this.$root && this.$root.querySelector ? this.$root.querySelector('.quiz-modal-body') : null;
          if (body) body.style.height = '';
        }.bind(this));
        this.releaseThemeUiState(options);
      },

      // ======== 步骤导航 ========

      /** 前进到下一步 */
      goNext() {
        if (!this.canGoNext) return;

        this.history.push(this.currentStep);
        this.currentStep = this.getNextStep();
        this.$nextTick(function() { this.updateBodyHeight(); }.bind(this));

        if (this.currentStep === 'result' || this.currentStep === 'tooSmall') {
          this.onQuizComplete();
          this.loadProductData();
        }
      },

      /** 回退到上一步 */
      goBack() {
        if (this.history.length === 0) return;
        this.currentStep = this.history.pop();
        this.$nextTick(function() { this.updateBodyHeight(); }.bind(this));
      },

      /** 获取当前步骤的答案值（用于埋点） */
      getCurrentAnswer() {
        switch (this.currentStep) {
          case 'neckSize':
            return this.answers.neckSizeKnown;
          case 'fenceNeed': return this.answers.fenceNeed;
          case 'dogProfile':
            return this.answers.breed + '/' + this.answers.ageMonths + 'mo/' + this.answers.weightLbs + 'lbs';
          case 'neckEstimateResult':
            return this.getEstimatedRangeLabel();
          case 'fenceArea': return this.answers.fenceArea;
          case 'distance': return this.answers.distance;
          case 'signal': return this.answers.signal;
          case 'signalRisk': return this.answers.signalRisk;
          case 'environment': return this.answers.environment;
          default: return '';
        }
      },

      /**
       * 计算下一步（状态机核心逻辑）
       *
       * 路由规则：
       * neckSize:  fits → fenceArea / small → fenceNeed / large → result(NOT_RECOMMENDED) / unknown → dogProfile
       * fenceNeed: 颈围<14 → tooSmall / 颈围正常(小院子) → result
       * dogProfile: 估算成功 → neckEstimateResult
       * neckEstimateResult: 估算<14 → fenceNeed / ≥14 → fenceArea
       * fenceArea: < 0.5 acre → fenceNeed / ≥ 0.5 acre → signal
       * signal: Poor → result(NOT_RECOMMENDED) / Excellent/Fair → environment
       * environment: residential/open → distance / denseWoods/city → signalRisk / other → result(NOT_RECOMMENDED)
       * distance: close → result(D1+Beacon) / far → result(D1)
       * signalRisk: needFence → result(NOT_RECOMMENDED) / trackingOnly → result(Collar Go)
       */
      getNextStep() {
        switch (this.currentStep) {
          case 'neckSize':
            if (this.answers.neckSizeKnown === 'unknown') return 'dogProfile';
            if (this.answers.neckSizeKnown === 'small') return 'fenceNeed';
            if (this.answers.neckSizeKnown === 'large') return 'result'; // >30 inches → 不建议购买
            return 'fenceArea'; // 'fits'

          case 'fenceNeed':
            // 颈围偏小 → tooSmall 页面（推荐 Collar Go 或不建议）
            if (this.effectiveNeckSize < 14) return 'tooSmall';
            // 小院子(< 0.5 acre) → 直接出结果
            return 'result';

          case 'dogProfile':
            return 'neckEstimateResult';

          case 'neckEstimateResult':
            if (this.answers.estimatedNeckMax !== null && this.answers.estimatedNeckMax < 14) return 'fenceNeed';
            if (this.answers.estimatedNeckMin !== null && this.answers.estimatedNeckMin > 30) return 'result';
            if (this.answers.estimatedNeckSize !== null && this.answers.estimatedNeckSize < 14) return 'fenceNeed';
            if (this.answers.estimatedNeckSize !== null && this.answers.estimatedNeckSize > 30) return 'result';
            return 'fenceArea';

          case 'fenceArea':
            // < 0.5 acre → 问是否需要围栏
            if (this.answers.fenceArea === 'small') return 'fenceNeed';
            // ≥ 0.5 acre → 问信号
            return 'signal';

          case 'signal':
            // Poor → 不建议购买
            if (this.answers.signal === 'poor') return 'result';
            // Excellent/Fair → 问环境
            return 'environment';

          case 'environment':
            // 好环境（住宅区/开阔地）→ 问距离
            if (this.answers.environment === 'suburban' || this.answers.environment === 'rural') return 'distance';
            // 差环境（密林/城市）→ 问是否需要围栏
            if (this.answers.environment === 'denseWoods' || this.answers.environment === 'city') return 'signalRisk';
            // Other → 不建议购买
            return 'result';

          case 'distance':
            // close(≤50ft) → D1+Beacon / far(>50ft) → D1，都直接出结果
            return 'result';

          case 'signalRisk':
            // needFence → NOT_RECOMMENDED, trackingOnly → Collar Go
            return 'result';

          default: return 'result';
        }
      },

      // ======== 颈围估算 ========

      /** 处理 dogProfile 步骤的"下一步" */
      async goNextDogProfile() {
        if (!this.canGoNext) return;

        this.loading = true;
        this.error = '';
        // 重置旧值，防止 429 限速时旧的 estimatedNeckSize 仍非 null 导致静默导航
        this.answers.estimatedNeckSize = null;
        this.answers.estimatedNeckMin = null;
        this.answers.estimatedNeckMax = null;
        this.answers.estimatedConfidence = '';
        this.answers.estimatedWarnings = [];

        try {
          await this.estimateNeckSize();
        } catch (err) {
          // 已在 estimateNeckSize 中处理
        }

        this.loading = false;

        if (this.answers.estimatedNeckSize !== null) {
          this.history.push(this.currentStep);
          this.currentStep = QUIZ_STEPS.neckEstimateResult;
          this.$nextTick(function() { this.updateBodyHeight(); }.bind(this));
        }
      },

      /** 使用前端本地算法估算颈围 */
      async estimateNeckSize() {
        try {
          var result = self.estimateLocalNeckFit({
            breedName: this.answers.breed,
            ageMonths: Number(this.answers.ageMonths),
            weightLbs: Number(this.answers.weightLbs)
          });

          this.answers.estimatedNeckSize = result.estimatedNeckSize;
          this.answers.estimatedNeckMin = result.estimatedNeckMin;
          this.answers.estimatedNeckMax = result.estimatedNeckMax;
          this.answers.estimatedConfidence = result.estimatedConfidence;
          this.answers.estimatedWarnings = result.warnings || [];
        } catch (err) {
          console.warn('[QuizModal] Local neck estimation failed:', err);
          this.error = 'Unable to estimate neck size. Please review your dog profile and try again.';
        }
      },

      // ======== 品种搜索 ========

      /** 品种搜索输入（防抖 200ms） */
      onBreedSearchInput() {
        clearTimeout(self.debounceTimer);
        self.debounceTimer = setTimeout(function() {
          this.filterBreeds();
        }.bind(this), 200);
      },

      /** 过滤品种列表 */
      filterBreeds() {
        var query = this.breedSearch.trim().toLowerCase();
        if (query.length === 0) {
          this.filteredBreeds = [];
          this.showBreedDropdown = false;
          return;
        }

        var allBreeds = self.breedsData ? self.breedsData.all : [];
        this.filteredBreeds = allBreeds.filter(function(breed) {
          return breed.toLowerCase().indexOf(query) !== -1;
        }).slice(0, 20);

        this.showBreedDropdown = this.filteredBreeds.length > 0;
      },

      /** 选择品种 */
      selectBreed(breed) {
        this.answers.breed = breed;
        this.breedSearch = breed;
        this.showBreedDropdown = false;
      },

      /** 选择热门品种标签 */
      selectFeaturedBreed(breed) {
        this.answers.breed = breed;
        this.breedSearch = breed;
        this.showBreedDropdown = false;
      },

      /** 关闭品种下拉，并将输入框文字作为自定义品种（支持混血等） */
      closeBreedDropdown() {
        setTimeout(function() {
          this.showBreedDropdown = false;
          // 如果用户没有从列表选择，但输入了文字，允许作为自定义品种
          var trimmed = (this.breedSearch || '').trim();
          if (trimmed && this.answers.breed !== trimmed) {
            this.answers.breed = trimmed;
          }
        }.bind(this), 200);
      },

      // ======== 推荐逻辑 ========

      /**
       * 计算推荐结果
       * 按流程图决策树依次判断：
       * 1. 颈围 <14 → Collar Go（via tooSmall 页面，不走这里）
       * 2. 颈围 >30 → NOT_RECOMMENDED
       * 3. < 0.5 acre + Essential → NOT_RECOMMENDED
       * 4. < 0.5 acre + Not essential → Collar Go
       * 5. ≥ 0.5 acre + ≤50ft → D1+Beacon
       * 6. ≥ 0.5 acre + >50ft + Poor → NOT_RECOMMENDED
       * 7. ≥ 0.5 acre + >50ft + Good/Fair + Residential/Open → D1
       * 8. ≥ 0.5 acre + >50ft + Good/Fair + DenseWoods/City + Essential → NOT_RECOMMENDED
       * 9. ≥ 0.5 acre + >50ft + Good/Fair + DenseWoods/City + Not essential → Collar Go
       * 10. ≥ 0.5 acre + >50ft + Good/Fair + Other → NOT_RECOMMENDED
       * @returns {String} 推荐结果常量
       */
      getRecommendation() {
        var answers = this.answers;
        var neckSize = this.effectiveNeckSize;

        // 1. 颈围超出 → 不建议购买
        if (neckSize > 30) return QUIZ_RESULTS.NOT_RECOMMENDED;

        // 2. 颈围偏小 → 根据围栏需求（via tooSmall 页面）
        if (neckSize < 14) {
          if (answers.fenceNeed === 'essential') return QUIZ_RESULTS.NOT_RECOMMENDED;
          return QUIZ_RESULTS.RECOMMEND_COLLAR_GO;
        }

        // 3. 小院子 (< 0.5 acre) → 根据围栏需求
        if (answers.fenceArea === 'small') {
          if (answers.fenceNeed === 'essential') return QUIZ_RESULTS.NOT_RECOMMENDED;
          return QUIZ_RESULTS.RECOMMEND_COLLAR_GO;
        }

        // 4. 大院子 + Poor 信号 → 直接不建议购买
        if (answers.signal === 'poor') return QUIZ_RESULTS.NOT_RECOMMENDED;

        // 5. 大院子 + Excellent/Fair → 看环境
        var env = answers.environment;

        // 5a. 差环境（密林/城市）→ 看围栏需求
        if (env === 'denseWoods' || env === 'city') {
          if (answers.signalRisk === 'needFence') return QUIZ_RESULTS.NOT_RECOMMENDED;
          return QUIZ_RESULTS.RECOMMEND_COLLAR_GO;
        }

        // 5b. Other / Not sure → 不建议购买
        if (env === 'other') return QUIZ_RESULTS.NOT_RECOMMENDED;

        // 6. 好环境（住宅区/开阔地）→ 看距离
        if (answers.distance === 'close') return QUIZ_RESULTS.RECOMMEND_COLLAR_BEACON;
        return QUIZ_RESULTS.RECOMMEND_COLLAR;
      },

      /**
       * 获取推荐结果的埋点 label
       */
      getResultLabel() {
        var map = {};
        map[QUIZ_RESULTS.RECOMMEND_COLLAR_GO] = 'collar_go';
        map[QUIZ_RESULTS.RECOMMEND_COLLAR_BEACON] = 'collar_beacon';
        map[QUIZ_RESULTS.RECOMMEND_COLLAR] = 'collar';
        map[QUIZ_RESULTS.NOT_RECOMMENDED] = 'not_recommended';
        return map[this.getRecommendation()] || 'unknown';
      },

      shouldShowCollarGoBandNotice() {
        if (this.currentStep !== 'result') return false;
        if (this.answers.neckSizeKnown !== 'unknown') return false;
        if (this.getRecommendation() !== QUIZ_RESULTS.RECOMMEND_COLLAR_GO) return false;

        var estimatedMin = this.answers.estimatedNeckMin !== null
          ? Number(this.answers.estimatedNeckMin)
          : Number(this.answers.estimatedNeckSize);
        var estimatedMax = this.answers.estimatedNeckMax !== null
          ? Number(this.answers.estimatedNeckMax)
          : Number(this.answers.estimatedNeckSize);

        if (!estimatedMin && estimatedMin !== 0) return false;
        if (!estimatedMax && estimatedMax !== 0) return false;

        return estimatedMax >= 27 && estimatedMin <= 30;
      },

      /**
       * 获取不推荐原因 key 列表
       * 根据用户回答判断具体不推荐的原因，用于结果页展示
       */
      getNotRecommendedReasonKeys() {
        var keys = [];
        var neckSize = this.effectiveNeckSize;
        var answers = this.answers;

        // 颈围超出
        if (neckSize > 30) keys.push('neckTooLarge');
        // 小院子 + 需要围栏
        if (answers.fenceArea === 'small' && answers.fenceNeed === 'essential') keys.push('smallYard');
        // 信号差
        if (answers.signal === 'poor') keys.push('weakSignal');
        // 环境不佳（密林/城市）+ 需要围栏
        if (['denseWoods', 'city'].indexOf(answers.environment) !== -1 && answers.signalRisk === 'needFence') keys.push('challengingEnv');
        // 环境不确定
        if (answers.environment === 'other') keys.push('unclearEnv');

        return keys;
      },

      // ======== Quiz 完成 ========

      /** Quiz 完成时触发事件 */
      onQuizComplete() {
        var label = this.getResultLabel();
        var riskKeys = this.getNotRecommendedReasonKeys();

        this.trackEvent('quiz_complete', {
          quiz_id: this.quizId,
          result_label: label,
          risk_flags: riskKeys.join(','),
          total_steps_taken: this.history.length,
          entry_point: this.entryPoint,
          event_data: {
            neckSize: this.answers.neckSizeKnown || undefined,
            breed: this.answers.breed || undefined,
            ageMonths: this.answers.ageMonths || undefined,
            weightLbs: this.answers.weightLbs || undefined,
            estimatedNeckSize: this.answers.estimatedNeckSize || undefined,
            estimatedNeckMin: this.answers.estimatedNeckMin || undefined,
            estimatedNeckMax: this.answers.estimatedNeckMax || undefined,
            fenceNeed: this.answers.fenceNeed || undefined,
            fenceArea: this.answers.fenceArea || undefined,
            distance: this.answers.distance || undefined,
            signal: this.answers.signal || undefined,
            signalRisk: this.answers.signalRisk || undefined,
            environment: this.answers.environment || undefined
          }
        });
      },

      /** 重新开始 Quiz */
      restartQuiz() {
        this.clearCloseTimer();
        this.openQuiz({ entryPoint: 'restart' });
      },

      /**
       * 加载结果页所需的产品数据（进入 result/tooSmall 步骤时调用）
       * 根据推荐结果决定拉哪些产品，并行 fetch，自动选中首个可购买 variant
       */
      loadProductData() {
        var handlesNode = document.querySelector('[data-quiz-product-handles]');
        if (!handlesNode) return;

        var collarHandle = handlesNode.getAttribute('data-collar-handle') || 'satellai-collar';
        var collarGoHandle = handlesNode.getAttribute('data-collar-go-handle') || 'satellai-collar-go';
        var beaconHandle = handlesNode.getAttribute('data-beacon-handle') || 'satellai-beacon';

        // 判断本次需要拉哪些产品
        var isTooSmallCollarGo = this.currentStep === 'tooSmall' && this.answers.fenceNeed === 'trackingOnly';
        var rec = isTooSmallCollarGo ? QUIZ_RESULTS.RECOMMEND_COLLAR_GO : this.getRecommendation();

        var state = this;
        var requests = [];

        // 从 Shopify product.json 拉取产品数据的辅助函数
        function fetchProduct(handle, key) {
          if (!handle) return Promise.resolve();
          if (state.productData[key]) return Promise.resolve(); // 已加载则跳过
          return fetch('/products/' + handle + '.js', {
            headers: {
              'Accept': 'application/json'
            }
          })
            .then(function(res) {
              if (!res.ok) {
                throw new Error('Product request failed: ' + res.status);
              }
              return res.text();
            })
            .then(function(text) {
              if (!text || !text.trim()) {
                throw new Error('Product response is empty');
              }

              var data = JSON.parse(text);
              var p = data && data.product ? data.product : data;

              if (!p || !p.variants) {
                throw new Error('Invalid product payload');
              }

              return p;
            })
            .then(function(data) {
              var p = data;
              var variants = (p.variants || []).map(function(v) {
                // Plan Bundle 类产品 available/inventory 字段均为 null（非 undefined），
                // 用宽松不等号 != 同时覆盖 null 和 undefined，两者均兜底为 true（上架即可购买）
                var available = (v.available != null) ? v.available : true;
                return { id: v.id, title: v.title, available: available };
              });
              var featuredImage = '';

              if (typeof p.featured_image === 'string') {
                featuredImage = p.featured_image;
              } else if (p.featured_image && p.featured_image.src) {
                featuredImage = p.featured_image.src;
              } else if (p.images && p.images[0]) {
                featuredImage = typeof p.images[0] === 'string' ? p.images[0] : (p.images[0].src || '');
              }

              state.productData[key] = {
                title: p.title,
                image: featuredImage,
                variants: variants
              };
              // 自动选中第一个可购买的 variant
              var first = variants.find(function(v) { return v.available; }) || variants[0];
              if (first) state.selectedVariantId[key] = first.id;
            })
            .catch(function(err) {
              console.warn('[QuizModal] 产品数据加载失败:', handle, err && err.message ? err.message : err);
            });
        }

        // 产品数据加载完成后重新测量高度（数据渲染后 scrollHeight 才准确）
        function afterLoad() {
          if (state.$nextTick) {
            state.$nextTick(function() { state.updateBodyHeight(); });
          }
        }

        if (rec === QUIZ_RESULTS.RECOMMEND_COLLAR) {
          requests.push(fetchProduct(collarHandle, 'collar'));
        } else if (rec === QUIZ_RESULTS.RECOMMEND_COLLAR_GO) {
          requests.push(fetchProduct(collarGoHandle, 'collarGo'));
        } else if (rec === QUIZ_RESULTS.RECOMMEND_COLLAR_BEACON) {
          requests.push(fetchProduct(collarHandle, 'collar'));
          requests.push(fetchProduct(beaconHandle, 'beacon'));
        }

        if (requests.length === 0) return;

        state.productsLoading = true;
        Promise.all(requests).finally(function() {
          state.productsLoading = false;
          afterLoad();
        });
      },

      /**
       * 直接加购物车（取代原 goToProduct 跳转逻辑）
       * 构建 items 数组后 POST /cart/add.js，成功后触发购物车更新
       */
      addToCart() {
        if (this.addingToCart) return;

        var isTooSmallCollarGo = this.currentStep === 'tooSmall' && this.answers.fenceNeed === 'trackingOnly';
        var rec = isTooSmallCollarGo ? QUIZ_RESULTS.RECOMMEND_COLLAR_GO : this.getRecommendation();

        // 构建加购 items
        var items = [];
        var quizId = this.quizId;

        if (rec === QUIZ_RESULTS.RECOMMEND_COLLAR && this.selectedVariantId.collar) {
          items.push({
            id: this.selectedVariantId.collar,
            quantity: 1,
            properties: self.getQuizLineItemProperties('collar', this.selectedVariantId.collar, quizId)
          });
        } else if (rec === QUIZ_RESULTS.RECOMMEND_COLLAR_GO && this.selectedVariantId.collarGo) {
          items.push({
            id: this.selectedVariantId.collarGo,
            quantity: 1,
            properties: self.getQuizLineItemProperties('collarGo', this.selectedVariantId.collarGo, quizId)
          });
        } else if (rec === QUIZ_RESULTS.RECOMMEND_COLLAR_BEACON) {
          if (this.selectedVariantId.collar) {
            items.push({
              id: this.selectedVariantId.collar,
              quantity: 1,
              properties: self.getQuizLineItemProperties('collar', this.selectedVariantId.collar, quizId)
            });
          }
          if (this.selectedVariantId.beacon) {
            items.push({
              id: this.selectedVariantId.beacon,
              quantity: 1,
              properties: self.getQuizLineItemProperties('beacon', this.selectedVariantId.beacon, quizId)
            });
          }
        }

        if (items.length === 0) return;

        this.addingToCart = true;
        this.cartError = '';
        var state = this;

        // 复用 Eurus 主题的 sections 机制：请求体携带需刷新的区块 ID，
        // Shopify 在响应中返回最新 HTML，直接注入 DOM（数量 badge + 购物车抽屉）
        var sectionsToRender = (window.Alpine && Alpine.store('xCartHelper'))
          ? Alpine.store('xCartHelper').getSectionsToRender()
          : [];

        self.setCartQuizId(quizId)
          .catch(function(err) {
            console.warn('[QuizModal] Failed to persist quiz_id cart attribute:', err);
          })
          .then(function() {
            return fetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({
                items: items,
                sections: sectionsToRender.map(function(s) { return s.id; })
              })
            });
          })
          .then(function(res) {
            if (!res.ok) {
              return res.json().then(function(err) { throw new Error(err.description || 'Add to cart failed'); });
            }
            return res.json();
          })
          .then(function(data) {
            document.dispatchEvent(new CustomEvent("gtm:product-added", {
              detail: {
                response: data
              }
            }));
            // 将 Shopify 返回的最新购物车区块 HTML 注入 DOM（与 Eurus 主题一致）
            sectionsToRender.forEach(function(section) {
              var el = document.querySelector(section.selector);
              if (el && data.sections && data.sections[section.id]) {
                var parser = new DOMParser();
                var parsed = parser.parseFromString(data.sections[section.id], 'text/html');
                var inner = parsed.querySelector(section.selector);
                el.innerHTML = inner ? inner.innerHTML : data.sections[section.id];
              }
            });

            state.addingToCart = false;
            state.cartSuccess = true;
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));

            // 埋点
            state.trackEvent('quiz_add_to_cart', {
              quiz_id: state.quizId,
              event_data: { resultLabel: state.getResultLabel() }
            });

            // 展示 600ms ✓ 后关闭 quiz + 打开购物车（单层 setTimeout，无嵌套）
            // quizId 校验：避免用户中途重开 quiz 时旧计时器把新 quiz 关掉
            var closeQuizId = state.quizId;
            state.clearCloseTimer();
            self.closeTimer = setTimeout(function() {
              if (state.quizId !== closeQuizId) return;
              self.closeTimer = null;
              state.closeQuiz({ preserveCart: true });
              if (window.Alpine && Alpine.store('xMiniCart')) {
                Alpine.store('xMiniCart').openCart();
              }
            }, 600);
          })
          .catch(function(err) {
            state.addingToCart = false;
            state.cartError = err.message || 'Failed to add to cart. Please try again.';
            console.warn('[QuizModal] 加购失败:', err);
          });
      },

      // ======== 选项选择辅助 ========

      /** 选择选项 */
      selectOption(field, value) {
        this.answers[field] = value;
      },

      /** 选择颈围区间 */
      selectNeckSizeKnown(value) {
        this.answers.neckSizeKnown = value;
      },

      /** 格式化年龄显示（月→年+月） */
      formatAge(months) {
        months = Number(months);
        if (months < 12) return months + ' mo';
        var years = Math.floor(months / 12);
        var remainMonths = months % 12;
        if (remainMonths === 0) return years + ' yr';
        return years + ' yr ' + remainMonths + ' mo';
      },

      /**
       * 获取推荐尺码信息
       * 返回颈围选择和有效颈围值，用于 add_to_cart 埋点
       */
      getRecommendedSize() {
        var neckChoice = this.answers.neckSizeKnown;
        var effective = this.effectiveNeckSize;
        if (neckChoice === 'fits') return 'fits_14-30in';
        if (neckChoice === 'small') return 'small_under14in';
        if (neckChoice === 'unknown' && effective) return 'estimated_' + effective + 'in';
        return neckChoice || 'unknown';
      },

      // ======== 埋点 Analytics ========

      /** 发送埋点事件到后端 CMS API */
      trackEvent(eventName, params) {
        var envConfig = window.EnvironmentConfig;
        if (!envConfig) return;

        var apiUrl = envConfig.getApiUrl('quizEventsApiUrl');
        var apiKey = envConfig.getApiKey();
        if (!apiUrl || !apiKey) return;

        var payload = JSON.stringify({
          apiKey: apiKey,
          eventType: eventName,
          quizId: params.quiz_id || this.quizId,
          sessionId: this.sessionId,
          step: params.step || undefined,
          resultLabel: params.result_label || undefined,
          riskFlags: params.risk_flags || undefined,
          totalStepsTaken: params.total_steps_taken || undefined,
          entryPoint: params.entry_point || undefined,
          pageUrl: window.location.href,
          userAgent: navigator.userAgent,
          eventData: params.event_data || undefined
        });

        // abandon 事件用 sendBeacon（页面关闭时更可靠）
        if (eventName === 'quiz_abandon' && navigator.sendBeacon) {
          navigator.sendBeacon(apiUrl, payload);
        } else {
          fetch(apiUrl, {
            method: 'POST',
            body: payload,
            keepalive: true
          }).catch(function() {});
        }
      }
    };
  }

  // ======== 静态辅助方法 ========

  /**
   * 获取或创建 session ID（存储在 sessionStorage 中）
   * 用于埋点去重和访客计数
   */
  getOrCreateSessionId() {
    try {
      var key = 'quiz_session_id';
      var id = sessionStorage.getItem(key);
      if (!id) {
        id = this.generateUUID();
        sessionStorage.setItem(key, id);
      }
      return id;
    } catch (e) {
      return this.generateUUID();
    }
  }

  /**
   * 将 quiz_id 写入购物车属性
   * Shopify 会自动将 cart attributes 转为订单的 note_attributes
   */
  setCartQuizId(quizId) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { quiz_id: quizId } })
    });
  }

  /** 生成 UUID */
  generateUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  normalizeBreedName(name) {
    var query = String(name || '').trim().toLowerCase();
    var aliasMap = {
      'mixed': 'mixed breed',
      'mixed breed dog': 'mixed breed',
      'doberman pinscher': 'doberman',
      'pembroke welsh corgi': 'corgi',
      'welsh corgi pembroke': 'corgi',
      'cavalier king charles spaniel': 'cavalier king charles',
      'english cocker spaniel': 'cocker spaniel'
    };

    return aliasMap[query] || query;
  }

  findDogBreed(name) {
    var query = this.normalizeBreedName(name);
    if (!query) return null;

    return COLLAR_FIT_DOG_BREEDS.find(function(breed) {
      return breed.name.toLowerCase() === query;
    }) || COLLAR_FIT_DOG_BREEDS.find(function(breed) {
      return breed.name.toLowerCase().indexOf(query) === 0;
    }) || COLLAR_FIT_DOG_BREEDS.find(function(breed) {
      return breed.name.toLowerCase().indexOf(query) !== -1;
    }) || null;
  }

  roundToSingleDecimal(value) {
    return Math.round(Number(value || 0) * 10) / 10;
  }

  roundToHalfStep(value) {
    return Math.round(Number(value || 0) * 2) / 2;
  }

  interpolateNeck(weightKg, anchors) {
    if (weightKg <= anchors[0][0]) return [anchors[0][1], anchors[0][2]];

    var last = anchors[anchors.length - 1];
    if (weightKg >= last[0]) return [last[1], last[2]];

    for (var i = 1; i < anchors.length; i++) {
      if (weightKg <= anchors[i][0]) {
        var prev = anchors[i - 1];
        var next = anchors[i];
        var t = (weightKg - prev[0]) / (next[0] - prev[0]);
        return [
          prev[1] + t * (next[1] - prev[1]),
          prev[2] + t * (next[2] - prev[2])
        ];
      }
    }

    return [last[1], last[2]];
  }

  loadQuizProductProperties() {
    if (this.quizProductProperties) return this.quizProductProperties;

    var node = document.querySelector('[data-quiz-product-properties]');
    if (!node) {
      this.quizProductProperties = { collar: {}, collarGo: {}, beacon: {} };
      return this.quizProductProperties;
    }

    try {
      this.quizProductProperties = JSON.parse(node.textContent || '{}');
    } catch (err) {
      console.warn('[QuizModal] Failed to parse quiz product properties:', err);
      this.quizProductProperties = { collar: {}, collarGo: {}, beacon: {} };
    }

    return this.quizProductProperties;
  }

  getQuizLineItemProperties(productKey, variantId, quizId) {
    var props = { _quiz_id: quizId };
    var productProperties = this.loadQuizProductProperties();
    var variantKey = String(variantId || '');
    var variantProperties =
      productProperties &&
      productProperties[productKey] &&
      variantKey &&
      productProperties[productKey][variantKey]
        ? productProperties[productKey][variantKey]
        : null;

    if (variantProperties && variantProperties._plan_variant_id) {
      props._plan_variant_id = String(variantProperties._plan_variant_id);
    }

    if (variantProperties && variantProperties._plan_extended_months) {
      props._plan_extended_months = String(variantProperties._plan_extended_months);
    }

    return props;
  }

  handleGlobalOpen(event) {
    if (!this.activeData || typeof this.activeData.openQuiz !== 'function') return;
    this.activeData.openQuiz(event && event.detail ? event.detail : {});
  }

  registerGlobalListeners() {
    if (this.globalListenersRegistered) return;
    window.addEventListener('quiz:open', this.globalOpenHandler);
    this.globalListenersRegistered = true;
  }

  getDogNeckRangeFromWeight(weightKg) {
    return this.interpolateNeck(weightKg, COLLAR_FIT_DOG_ANCHORS);
  }

  getDogLifeStage(ageYears, avgAdultKg) {
    var puppyCutoff = 0.75;
    var seniorCutoff = 9;

    if (avgAdultKg < 10) {
      puppyCutoff = 0.75;
      seniorCutoff = 9;
    } else if (avgAdultKg < 25) {
      puppyCutoff = 1.0;
      seniorCutoff = 8;
    } else if (avgAdultKg < 45) {
      puppyCutoff = 1.5;
      seniorCutoff = 7;
    } else {
      puppyCutoff = 2.0;
      seniorCutoff = 6;
    }

    if (ageYears < puppyCutoff) return 'puppy';
    if (ageYears < puppyCutoff + 0.5) return 'young';
    if (ageYears < seniorCutoff) return 'adult';
    return 'senior';
  }

  estimateLocalNeckFit(options) {
    var breedName = options && options.breedName ? options.breedName : '';
    var ageMonths = Number(options && options.ageMonths);
    var weightLbs = Number(options && options.weightLbs);

    if (!breedName || ageMonths <= 0 || weightLbs <= 0) {
      throw new Error('Invalid dog profile for neck estimation');
    }

    var weightKg = weightLbs / 2.20462;
    var ageYears = ageMonths / 12;
    var collarMin = 14;
    var collarMax = 30;
    var resolvedBreed = this.findDogBreed(breedName);
    var factor = resolvedBreed ? resolvedBreed.neckFactor : 1.0;
    var warnings = [];

    if (breedName && !resolvedBreed) {
      warnings.push('Breed "' + breedName + '" not found - using generic neckFactor 1.0');
    }

    var avgAdultKg = resolvedBreed
      ? (resolvedBreed.adultWeight[0] + resolvedBreed.adultWeight[1]) / 2
      : 20;
    var stage = this.getDogLifeStage(ageYears, avgAdultKg);
    var baseNeck = this.getDogNeckRangeFromWeight(weightKg);
    var seniorAtrophy = stage === 'senior' ? 0.90 : 1.0;
    var currentNeck = {
      min: this.roundToSingleDecimal(baseNeck[0] * factor * seniorAtrophy),
      max: this.roundToSingleDecimal(baseNeck[1] * factor * seniorAtrophy)
    };

    if (resolvedBreed) {
      var minAdultWeight = resolvedBreed.adultWeight[0];
      var maxAdultWeight = resolvedBreed.adultWeight[1];
      if (stage === 'adult' || stage === 'senior') {
        if (weightKg > maxAdultWeight * 2) {
          warnings.push('Weight ' + weightKg + 'kg far exceeds breed max ' + maxAdultWeight + 'kg (>2x)');
        } else if (weightKg < minAdultWeight * 0.3) {
          warnings.push('Weight ' + weightKg + 'kg unusually low for breed (expected >=' + minAdultWeight + 'kg)');
        }
      } else if (weightKg > maxAdultWeight * 1.5) {
        warnings.push('Weight ' + weightKg + 'kg exceeds breed adult max ' + maxAdultWeight + 'kg for a ' + stage);
      }
    }

    var isGrowing = stage === 'puppy' || stage === 'young';
    var adultNeck = null;
    var fitNeck = currentNeck;
    var fit = 'perfect';
    var growthThreshold = stage === 'young' ? 0.95 : 0.85;

    if (isGrowing && resolvedBreed && weightKg < avgAdultKg * growthThreshold) {
      var adultBaseNeck = this.getDogNeckRangeFromWeight(avgAdultKg);
      adultNeck = {
        min: this.roundToSingleDecimal(adultBaseNeck[0] * factor),
        max: this.roundToSingleDecimal(adultBaseNeck[1] * factor)
      };
      fitNeck = adultNeck;
    }

    if (fitNeck.max < collarMin) {
      fit = 'too-small';
    } else if (fitNeck.min > collarMax) {
      fit = 'too-large';
    } else if (fitNeck.min >= collarMin && fitNeck.max <= collarMax) {
      fit = 'perfect';
    } else {
      fit = 'maybe';
    }

    return {
      breedName: resolvedBreed ? resolvedBreed.name : null,
      estimatedNeckMin: fitNeck.min,
      estimatedNeckMax: fitNeck.max,
      estimatedNeckSize: this.roundToHalfStep((fitNeck.min + fitNeck.max) / 2),
      estimatedConfidence: !resolvedBreed ? 'low' : (warnings.length > 0 || isGrowing ? 'medium' : 'high'),
      stage: stage,
      fit: fit,
      currentNeck: currentNeck,
      adultNeck: adultNeck,
      warnings: warnings
    };
  }

  /**
   * 将 Section settings 注入的 hidden 图片复制到可见容器中
   * 图片在 section liquid 中以 hidden img[data-quiz-img-*] 形式注入
   * 这里把 src 复制到对应的可见容器里，实现后台可配置图片
   */
  populateRefImages() {
    var imageMap = [
      { src: '[data-quiz-img-neck-size]', target: '#quiz-img-neck-size' },
      { src: '[data-quiz-img-env-suburban]', target: '#quiz-img-env-suburban' },
      { src: '[data-quiz-img-env-rural]', target: '#quiz-img-env-rural' },
      { src: '[data-quiz-img-env-dense-woods]', target: '#quiz-img-env-dense-woods' },
      { src: '[data-quiz-img-env-city]', target: '#quiz-img-env-city' },
      { src: '[data-quiz-img-env-other]', target: '#quiz-img-env-other' }
    ];

    imageMap.forEach(function(item) {
      var srcEl = document.querySelector(item.src);
      var targetEl = document.querySelector(item.target);
      if (srcEl && targetEl && srcEl.src) {
        targetEl.innerHTML = '<img src="' + srcEl.src + '" alt="' + (srcEl.alt || '') + '" loading="lazy">';
      }
    });
  }

  /**
   * 异步加载品种数据（4个JSON文件合并）
   * @param {Object} component - Alpine 组件实例
   */
  async loadBreedsData(component) {
    if (this.breedsData) {
      component.featuredBreeds = this.breedsData.featured;
      component.breedsLoaded = true;
      return;
    }

    try {
      var featuredUrl = document.querySelector('[data-quiz-breeds-featured]');
      var afUrl = document.querySelector('[data-quiz-breeds-af]');
      var gnUrl = document.querySelector('[data-quiz-breeds-gn]');
      var ozUrl = document.querySelector('[data-quiz-breeds-oz]');

      if (!featuredUrl || !afUrl || !gnUrl || !ozUrl) {
        console.warn('[QuizModal] Breed data URLs not found in DOM');
        component.breedsLoaded = true; // 即使没有 URL 也标记完成，避免永远 loading
        return;
      }

      var responses = await Promise.all([
        fetch(featuredUrl.getAttribute('data-quiz-breeds-featured')),
        fetch(afUrl.getAttribute('data-quiz-breeds-af')),
        fetch(gnUrl.getAttribute('data-quiz-breeds-gn')),
        fetch(ozUrl.getAttribute('data-quiz-breeds-oz'))
      ]);

      var results = await Promise.all(responses.map(function(r) { return r.json(); }));

      this.breedsData = {
        featured: results[0],
        all: [].concat(results[1], results[2], results[3])
      };

      component.featuredBreeds = this.breedsData.featured;
    } catch (err) {
      console.warn('[QuizModal] Failed to load breed data:', err);
    }
    component.breedsLoaded = true;
  }
}

// ========================================
// 注册 Alpine 组件
// ========================================
(function() {
  var registerComponent = function() {
    if (window.Alpine && !Alpine.data.__quizModalRegistered) {
      var instance = new QuizModalComponent();
      instance.registerGlobalListeners();
      Alpine.data('quizModal', function() {
        var data = instance.init();
        data.init = data.alpineInit;
        delete data.alpineInit;
        return data;
      });
      Alpine.data.__quizModalRegistered = true;
    }
  };

  if (window.Alpine) {
    registerComponent();
  } else {
    document.addEventListener('alpine:init', registerComponent);
  }
})();

} /* end guard */
